import { render, staticRenderFns } from "./growValue.vue?vue&type=template&id=a4b653e4&scoped=true&"
import script from "./growValue.vue?vue&type=script&lang=ts&"
export * from "./growValue.vue?vue&type=script&lang=ts&"
import style0 from "./growValue.vue?vue&type=style&index=0&id=a4b653e4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4b653e4",
  null
  
)

export default component.exports